export const serviceLandings = {
  'iphone-repair': {
    slug: 'iphone-repair',
    path: '/services/iphone-repair',
    title: 'Ремонт iPhone Харків',
    description: 'Ремонт iPhone у Харкові: заміна екрана, батареї, камери, розʼєму зарядки та відновлення після води з гарантією.',
    h1: 'Ремонт iPhone у Харкові',
    intro: 'Ремонтуємо iPhone усіх поколінь: від заміни скла та батареї до складного ремонту після падіння чи залиття.',
    category: '',
    brandTerms: ['iphone', 'apple'],
    keywords: ['ремонт iPhone Харків', 'терміновий ремонт iPhone Харків', 'ремонт айфонів Харків'],
    benefits: [
      'Діагностика та погодження ціни до початку робіт',
      'Запчастини під конкретну модель iPhone',
      'Гарантія до 12 місяців'
    ],
    faq: [
      { q: 'Скільки коштує ремонт iPhone у Харкові?', a: 'Популярні ремонти iPhone стартують від 1100 грн, точну вартість називаємо після огляду.' },
      { q: 'Чи ремонтуєте iPhone 15?', a: 'Так, приймаємо iPhone 15, Plus, Pro та Pro Max.' }
    ]
  },
  'samsung-repair': {
    slug: 'samsung-repair',
    path: '/services/samsung-repair',
    title: 'Ремонт Samsung Харків',
    description: 'Ремонт Samsung Galaxy у Харкові: AMOLED-екрани, батареї, розʼєми зарядки, камери та ремонт після води.',
    h1: 'Ремонт Samsung Galaxy у Харкові',
    intro: 'Обслуговуємо серії Galaxy S, A, M та Note. Підбираємо деталі під конкретну модель і чесно озвучуємо строки.',
    category: '',
    brandTerms: ['samsung', 'galaxy'],
    keywords: ['ремонт Samsung Харків', 'ремонт Samsung Galaxy Харків', 'заміна екрана Samsung Харків'],
    benefits: [
      'Працюємо з популярними моделями Galaxy',
      'Швидкий запис через сайт, Telegram або телефон',
      'Перевірка екрана, сенсора та зарядки після ремонту'
    ],
    faq: [
      { q: 'Чи міняєте дисплеї Samsung Galaxy?', a: 'Так, виконуємо заміну екранів та дисплейних модулів для серій S, A, M і Note.' },
      { q: 'Скільки триває ремонт Samsung?', a: 'Типові роботи займають від 30 хвилин до 2 годин, складні ремонти довше.' }
    ]
  },
  'xiaomi-repair': {
    slug: 'xiaomi-repair',
    path: '/services/xiaomi-repair',
    title: 'Ремонт Xiaomi Харків',
    description: 'Ремонт Xiaomi, Redmi та POCO у Харкові: дисплей, батарея, камера, розʼєм зарядки та відновлення після води.',
    h1: 'Ремонт Xiaomi, Redmi та POCO у Харкові',
    intro: 'Працюємо з популярними моделями Xiaomi, Redmi і POCO, швидко підбираємо деталі та даємо зрозумілий кошторис.',
    category: '',
    brandTerms: ['xiaomi', 'redmi', 'poco'],
    keywords: ['ремонт Xiaomi Харків', 'ремонт Redmi Харків', 'ремонт POCO Харків'],
    benefits: [
      'Недорогий ремонт масових моделей',
      'Підбір батарей і дисплеїв під конкретний смартфон',
      'Термінові ремонти у день звернення'
    ],
    faq: [
      { q: 'Чи ремонтуєте Redmi та POCO?', a: 'Так, приймаємо Xiaomi, Redmi і POCO включно з популярними серіями Note, X та M.' },
      { q: 'Чи можна одразу дізнатися ціну?', a: 'Після короткої діагностики озвучуємо точну суму до старту ремонту.' }
    ]
  },
  'screen-replacement': {
    slug: 'screen-replacement',
    path: '/services/screen-replacement',
    title: 'Заміна екрану Харків',
    description: 'Заміна екрану телефону у Харкові для iPhone, Samsung, Xiaomi та інших моделей з гарантією на встановлення.',
    h1: 'Заміна екрану телефону у Харкові',
    intro: 'Міняємо дисплеї та модулі, коли тріснуло скло, не працює сенсор або зникло зображення після падіння.',
    category: 'screen',
    brandTerms: [],
    keywords: ['заміна екрану Харків', 'заміна дисплея Харків', 'заміна скла телефону Харків'],
    benefits: [
      'Працюємо з популярними брендами смартфонів',
      'Перевіряємо сенсор, яскравість і кольори після встановлення',
      'Гарантія на заміну дисплея'
    ],
    faq: [
      { q: 'Скільки коштує заміна екрана?', a: 'Для масових моделей ремонт стартує приблизно від 1100 грн, точна ціна залежить від моделі.' },
      { q: 'Чи можна замінити лише скло?', a: 'Так, якщо матриця ціла і сенсор працює коректно.' }
    ]
  },
  'battery-replacement': {
    slug: 'battery-replacement',
    path: '/services/battery-replacement',
    title: 'Заміна батареї Харків',
    description: 'Заміна батареї телефону у Харкові для iPhone, Samsung, Xiaomi та інших смартфонів. Швидко, з перевіркою після ремонту.',
    h1: 'Заміна батареї телефону у Харкові',
    intro: 'Допомагаємо, коли телефон швидко розряджається, гріється, вимикається на холоді або батарея втратила ємність.',
    category: 'battery',
    brandTerms: [],
    keywords: ['заміна батареї Харків', 'заміна акумулятора Харків', 'поміняти батарею телефону Харків'],
    benefits: [
      'Швидка заміна акумулятора',
      'Підбір батареї під точну модель',
      'Контроль автономності після встановлення'
    ],
    faq: [
      { q: 'Коли потрібно міняти батарею?', a: 'Коли смартфон швидко сідає, гріється, вимикається або помітно втратив автономність.' },
      { q: 'Скільки часу триває заміна батареї?', a: 'У більшості випадків від 20 до 40 хвилин.' }
    ]
  },
  'water-damage-repair': {
    slug: 'water-damage-repair',
    path: '/services/water-damage-repair',
    title: 'Ремонт після води Харків',
    description: 'Ремонт телефону після води у Харкові: чищення, відновлення плати, заміна пошкоджених модулів та чесна оцінка ризиків.',
    h1: 'Ремонт телефону після води у Харкові',
    intro: 'Рятуємо смартфони після потрапляння води, кави та інших рідин. Чим швидше звернетеся, тим вищий шанс на успішне відновлення.',
    category: 'water-damage',
    brandTerms: [],
    keywords: ['ремонт після води Харків', 'ремонт після залиття Харків', 'ремонт телефону після води гарантія Харків'],
    benefits: [
      'Термінова допомога після залиття',
      'Ультразвукове чищення та діагностика',
      'Працюємо з iPhone, Samsung, Xiaomi та іншими брендами'
    ],
    faq: [
      { q: 'Що робити, якщо телефон впав у воду?', a: 'Не вмикайте та не заряджайте його. Якнайшвидше везіть телефон у сервіс на чистку.' },
      { q: 'Чи можна врятувати телефон після залиття?', a: 'У багатьох випадках так, якщо звернутися в перші години після контакту з рідиною.' }
    ]
  },
  'charging-port-repair': {
    slug: 'charging-port-repair',
    path: '/services/charging-port-repair',
    title: 'Ремонт розʼєму зарядки Харків',
    description: 'Ремонт розʼєму зарядки телефону у Харкові: Lightning, USB-C та micro-USB для популярних моделей смартфонів.',
    h1: 'Ремонт розʼєму зарядки телефону у Харкові',
    intro: 'Допомагаємо, коли телефон не заряджається, кабель відходить або порт люфтить і зникає контакт.',
    category: 'charging',
    brandTerms: [],
    keywords: ['ремонт розʼєму зарядки Харків', 'телефон не заряджається Харків', 'заміна розʼєму зарядки Харків'],
    benefits: [
      'Швидка заміна або відновлення розʼєму',
      'Перевірка живлення та плати',
      'Ремонт сучасних і старих моделей'
    ],
    faq: [
      { q: 'Телефон заряджається через раз. Це точно розʼєм?', a: 'Часто так, але ми також перевіряємо кабель, батарею та контролер живлення.' },
      { q: 'Скільки триває ремонт розʼєму?', a: 'У середньому від 30 хвилин до 1 години.' }
    ]
  },
  'remont-iphone-15': {
    slug: 'remont-iphone-15',
    path: '/services/remont-iphone-15',
    title: 'Ремонт iPhone 15 Харків',
    description: 'Ремонт iPhone 15 у Харкові: заміна екрана, батареї, заднього скла, камер і відновлення після падіння.',
    h1: 'Ремонт iPhone 15 у Харкові',
    intro: 'Окрема сторінка під комерційний запит ремонт iPhone 15 Харків з акцентом на швидкий сервіс і запчастини під серію 15.',
    category: '',
    brandTerms: ['iphone', 'apple'],
    keywords: ['ремонт iPhone 15 Харків', 'ремонт iPhone 15 Pro Харків', 'ремонт iPhone 15 Pro Max Харків'],
    benefits: [
      'Працюємо з усією лінійкою iPhone 15',
      'Екран, батарея, камери та заднє скло',
      'Ремонт у день звернення для популярних поломок'
    ],
    faq: [
      { q: 'Чи ремонтуєте всю лінійку iPhone 15?', a: 'Так, приймаємо iPhone 15, Plus, Pro та Pro Max.' },
      { q: 'Чи є гарантія на ремонт iPhone 15?', a: 'Так, залежно від типу робіт гарантія діє до 12 місяців.' }
    ]
  },
  'zamena-ekrana-samsung': {
    slug: 'zamena-ekrana-samsung',
    path: '/services/zamena-ekrana-samsung',
    title: 'Заміна екрану Samsung Galaxy Харків ціна',
    description: 'Заміна екрану Samsung Galaxy у Харкові: ціни, строки, популярні моделі S, A, M та Note.',
    h1: 'Заміна екрану Samsung Galaxy у Харкові',
    intro: 'Сторінка під запит заміна екрана Samsung Galaxy Харків ціна з акцентом на AMOLED-матриці, строки та перевірку після ремонту.',
    category: 'screen',
    brandTerms: ['samsung', 'galaxy'],
    keywords: ['заміна екрану Samsung Galaxy Харків ціна', 'заміна дисплея Samsung Харків', 'екран Samsung Galaxy Харків'],
    benefits: [
      'Працюємо з Galaxy S, A, M та Note',
      'Підбір матриці під конкретну модель',
      'Перевірка сенсора, яскравості й кольорів після заміни'
    ],
    faq: [
      { q: 'Скільки коштує екран Samsung Galaxy?', a: 'Точна ціна залежить від моделі, популярні ремонти стартують приблизно від 1800 грн.' },
      { q: 'Чи збережеться сенсор після заміни?', a: 'Так, після встановлення обовʼязково перевіряємо сенсор і зображення.' }
    ]
  },
  'zamena-skla-iphone': {
    slug: 'zamena-skla-iphone',
    path: '/services/zamena-skla-iphone',
    title: 'Заміна скла iPhone Харків',
    description: 'Заміна скла iPhone у Харкові, якщо матриця ціла і потрібне відновлення без повної заміни дисплея.',
    h1: 'Заміна скла iPhone у Харкові',
    intro: 'Окрема сторінка під комерційний запит заміна скла iPhone Харків із поясненням, коли можна міняти саме скло, а не весь модуль.',
    category: 'screen',
    brandTerms: ['iphone', 'apple'],
    keywords: ['заміна скла iPhone Харків', 'заміна скла айфона Харків', 'скло iPhone Харків ціна'],
    benefits: [
      'Економія, якщо матриця не пошкоджена',
      'Працюємо з популярними моделями iPhone',
      'Гарантія на виконані роботи'
    ],
    faq: [
      { q: 'Коли можна міняти тільки скло iPhone?', a: 'Коли є зображення, сенсор працює, а пошкоджене лише верхнє скло.' },
      { q: 'Чим відрізняється заміна скла від заміни екрана?', a: 'При заміні скла змінюється лише верхній шар, а не весь дисплейний модуль.' }
    ]
  },
  'zamena-batarei-samsung': {
    slug: 'zamena-batarei-samsung',
    path: '/services/zamena-batarei-samsung',
    title: 'Заміна батареї Samsung Харків',
    description: 'Заміна батареї Samsung у Харкові для Galaxy S, A, M та інших моделей із перевіркою після встановлення.',
    h1: 'Заміна батареї Samsung у Харкові',
    intro: 'Допомагаємо, коли Samsung швидко розряджається, гріється або втратив автономність після активного використання.',
    category: 'battery',
    brandTerms: ['samsung', 'galaxy'],
    keywords: ['заміна батареї Samsung Харків', 'акумулятор Samsung Харків', 'поміняти батарею Samsung Galaxy Харків'],
    benefits: [
      'Підбір батареї під точну модель Galaxy',
      'Швидка заміна без зайвого очікування',
      'Перевірка зарядки та нагріву після ремонту'
    ],
    faq: [
      { q: 'Скільки триває заміна батареї Samsung?', a: 'У середньому від 20 до 40 хвилин залежно від моделі.' },
      { q: 'Чи даєте гарантію на батарею?', a: 'Так, гарантія залежить від конкретної деталі та виду ремонту.' }
    ]
  },
  'terminovyi-remont-telefoniv-kharkiv': {
    slug: 'terminovyi-remont-telefoniv-kharkiv',
    path: '/services/terminovyi-remont-telefoniv-kharkiv',
    title: 'Терміновий ремонт телефонів Харків',
    description: 'Терміновий ремонт телефонів у Харкові в день звернення: екран, батарея, зарядка, вода та інші типові поломки.',
    h1: 'Терміновий ремонт телефонів у Харкові',
    intro: 'Окрема сторінка під гарячі запити, коли людині потрібно швидко полагодити телефон і отримати зворотний звʼязок без затримки.',
    category: '',
    brandTerms: [],
    keywords: ['терміновий ремонт телефонів Харків', 'швидкий ремонт смартфонів Харків', 'ремонт телефону в день звернення Харків'],
    benefits: [
      'Оперативний дзвінок або відповідь у месенджері',
      'Популярні ремонти у день звернення',
      'Зручний запис через сайт, Telegram, Viber або WhatsApp'
    ],
    faq: [
      { q: 'Чи реально полагодити телефон сьогодні?', a: 'Так, багато типових ремонтів виконуємо у день звернення.' },
      { q: 'Чи потрібно записуватися заздалегідь?', a: 'Бажано залишити заявку, щоб ми підготували потрібні деталі та не втрачали ваш час.' }
    ]
  },
  'remont-iphone-pislia-vody': {
    slug: 'remont-iphone-pislia-vody',
    path: '/services/remont-iphone-pislia-vody',
    title: 'Ремонт iPhone після води Харків',
    description: 'Ремонт iPhone після води у Харкові: чистка, відновлення плати, розʼєму зарядки, камер та інших пошкоджених вузлів.',
    h1: 'Ремонт iPhone після води у Харкові',
    intro: 'Спеціальна сторінка під запит ремонт iPhone після води Харків з акцентом на швидке звернення та чесну оцінку шансів на відновлення.',
    category: 'water-damage',
    brandTerms: ['iphone', 'apple'],
    keywords: ['ремонт iPhone після води Харків', 'iPhone впав у воду Харків', 'айфон після води ремонт Харків'],
    benefits: [
      'Термінова діагностика після залиття',
      'Працюємо з усіма моделями iPhone',
      'Чим раніше звернення, тим вищий шанс на успіх'
    ],
    faq: [
      { q: 'Що робити з iPhone після води?', a: 'Не заряджайте та не вмикайте його, одразу везіть у сервіс на чистку.' },
      { q: 'Чи можна врятувати iPhone після залиття?', a: 'Так, особливо якщо звернутися протягом перших годин.' }
    ]
  },
  'bezkoshtovna-diahnostyka-kharkiv': {
    slug: 'bezkoshtovna-diahnostyka-kharkiv',
    path: '/services/bezkoshtovna-diahnostyka-kharkiv',
    title: 'Безкоштовна діагностика телефонів Харків',
    description: 'Безкоштовна діагностика телефонів у Харкові перед ремонтом: iPhone, Samsung, Xiaomi та інші моделі.',
    h1: 'Безкоштовна діагностика телефонів у Харкові',
    intro: 'Сторінка під довгий хвіст безкоштовна діагностика телефонів Харків з акцентом на прозорий кошторис перед ремонтом.',
    category: '',
    brandTerms: [],
    keywords: ['безкоштовна діагностика телефонів Харків', 'діагностика смартфона Харків', 'перевірка телефону перед ремонтом Харків'],
    benefits: [
      'Озвучуємо суму до початку робіт',
      'Пояснюємо, що саме зламалося і чому',
      'Підходить для простих і складних поломок'
    ],
    faq: [
      { q: 'Чи справді діагностика безкоштовна?', a: 'Так, попередній огляд і базова діагностика безкоштовні.' },
      { q: 'Скільки часу займає діагностика?', a: 'Прості випадки займають до 15 хвилин, складні ремонти після води потребують більше часу.' }
    ]
  },
  'remont-telefonov-kharkov': {
    slug: 'remont-telefonov-kharkov',
    path: '/services/remont-telefonov-kharkov',
    title: 'Ремонт телефонов Харьков',
    description: 'Ремонт телефонов в Харькове: iPhone, Samsung, Xiaomi и другие модели. Экран, батарея, разъем зарядки, после воды и срочный ремонт от 350 грн.',
    h1: 'Ремонт телефонов в Харькове',
    intro: 'Отдельная посадочная страница под коммерческие запросы ремонт телефона, ремонт телефонов Харьков и ремонт смартфонов Харьков с акцентом на быстрый прием заявок и понятную стоимость.',
    category: '',
    brandTerms: ['iphone', 'samsung', 'xiaomi', 'redmi', 'poco'],
    keywords: ['ремонт телефона Харьков', 'ремонт телефонов Харьков', 'ремонт смартфонов Харьков'],
    benefits: [
      'Срочный ремонт телефонов в день обращения',
      'Работаем с iPhone, Samsung, Xiaomi, Redmi, POCO и другими моделями',
      'Бесплатная диагностика, Telegram и телефон для быстрого контакта'
    ],
    faq: [
      { q: 'Сколько стоит ремонт телефона в Харькове?', a: 'Базовые ремонты стартуют от 350 грн, точную стоимость называем после диагностики.' },
      { q: 'Можно ли приехать без записи?', a: 'Да, но заявка через сайт или мессенджер помогает быстрее принять телефон в работу.' }
    ]
  }
};

export const serviceLandingList = Object.values(serviceLandings);
